var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisability = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Disability-Heart-Plus--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Disability Heart Plus Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.25 3.01a2.5 2.5 0 1 0 5 0 2.5 2.5 0 1 0 -5 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.91 17.69a3.48 3.48 0 0 0 -3.49 -3.18H7a0.51 0.51 0 0 1 -0.5 -0.46l-0.77 -5.26a1.5 1.5 0 1 0 -3 0.43l0.76 5.25a3.51 3.51 0 0 0 3.47 3h2.46a0.49 0.49 0 0 1 0.5 0.44l0.33 4.66a1.5 1.5 0 1 0 3 -0.24Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 18.76H1a1 1 0 0 0 0 2h6.5a1 1 0 0 0 0 -2Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.63 1.92A3.58 3.58 0 0 0 18 1l-1 0.9 -1 -0.9a3.58 3.58 0 0 0 -5.66 0.9 3.41 3.41 0 0 0 0.66 4l5.61 5.73a0.51 0.51 0 0 0 0.72 0L23 5.91a3.41 3.41 0 0 0 0.63 -3.99ZM19.5 6.5a0.25 0.25 0 0 1 -0.25 0.25H18a0.25 0.25 0 0 0 -0.25 0.25v1.25a0.25 0.25 0 0 1 -0.25 0.25h-1a0.25 0.25 0 0 1 -0.25 -0.25V7a0.25 0.25 0 0 0 -0.25 -0.25h-1.25a0.25 0.25 0 0 1 -0.25 -0.25v-1a0.25 0.25 0 0 1 0.25 -0.25H16a0.25 0.25 0 0 0 0.25 -0.25V3.75a0.25 0.25 0 0 1 0.25 -0.25h1a0.25 0.25 0 0 1 0.25 0.25V5a0.25 0.25 0 0 0 0.25 0.25h1.25a0.25 0.25 0 0 1 0.25 0.25Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisability);
export default ForwardRef;